// G-C5: literales en euskera (default) y castellano.
export type Lang = 'eu' | 'es'

const DICT = {
  asistencia: { eu: 'Asistentzia', es: 'Asistencia' },
  jugador: { eu: 'Jokalaria', es: 'Jugador' },
  sesionPorc: { eu: 'SAIOA %', es: 'SESIÓN %' },
  total: { eu: 'TOTALA', es: 'TOTAL' },
  editar: { eu: 'Editatu', es: 'Editar' },
  guardar: { eu: 'Gorde', es: 'Guardar' },
  anadirJugador: { eu: '+ Jokalaria', es: '+ Jugador' },
  // Issue #80 (club, 2026-10-22): entrenadores y delegados en la plantilla.
  anadirEntrenador: { eu: '+ Entrenatzailea', es: '+ Entrenador' },
  anadirDelegado: { eu: '+ Ordezkaria', es: '+ Delegado' },
  // Issue #76: Excel individual del jugador.
  excelJugador: { eu: '⬇ Excel', es: '⬇ Excel' },
  // Distinto del «Rol» del entrenador (principal/ayudante…), que ya existía en la ficha.
  tipoMiembro: { eu: 'Kide mota', es: 'Tipo de miembro' },
  grupoConFicha: { eu: 'Jokalaria (fitxaduna)', es: 'Jugador (con ficha)' },
  grupoSinFicha: { eu: 'Jokalaria (fitxarik gabe)', es: 'Jugador (sin ficha)' },
  grupoEntrenador: { eu: 'Entrenatzailea', es: 'Entrenador' },
  grupoDelegado: { eu: 'Ordezkaria', es: 'Delegado' },
  nuevoMiembro: { eu: 'Kide berria', es: 'Nuevo miembro' },
  anadidoPlantilla: { eu: '{nombre} plantillan gehitu da ({rol})', es: '{nombre} añadido a la plantilla ({rol})' },
  rolDelegadoNota: { eu: 'Ordezkariek ez dute asistentziarik ez minutajerik', es: 'Los delegados no cuentan en asistencia ni en minutaje' },
  rolEntrenadorNota: { eu: 'Entrenatzaileen asistentzia ALERTA › Entrenatzaileak atalean dago', es: 'La asistencia de entrenadores está en ALERTA › Entrenadores' },
  exportarCsv: { eu: '⬇ CSV', es: '⬇ CSV' },
  anadirEntrenamiento: { eu: '+ Entrenamendua', es: '+ Añadir entrenamiento' },
  // Bug real del club, 2026-10-02 (feedback por vídeo): "no sé muy bien cómo se añade, no sé muy
  // bien qué tengo que poner" — el prompt reutilizaba el texto del botón ("+ Añadir entrenamiento")
  // como pregunta, sin decir qué formato de fecha se espera. Mensaje propio, con formato explícito.
  // Club, 2026-10-13: con texto libre "6/10/2026" se guardaba como 10 de junio. Desde el 2026-10-23
  // la fecha se elige con un selector de fecha (`AddEntrenamientoModal`), sin formato que escribir.
  nuevoEntrenamiento: { eu: 'Entrenamendu berria', es: 'Nuevo entrenamiento' },
  fechaEntrenamiento: { eu: 'Entrenamenduaren data', es: 'Fecha del entrenamiento' },
  // Feedback del club por vídeo, 2026-10-11: antes "vacío = no asiste (no cuenta para el %)" ya no
  // es cierto — una celda vacía de una sesión YA CELEBRADA SÍ cuenta ahora, como falta (solo las
  // sesiones futuras quedan fuera de cualquier cómputo). Texto actualizado para no confundir.
  leyendaMarcado: {
    eu: '✓ = bertaratu da · hutsik = ez da bertaratu (igarotako saioetan hutsegite gisa kontatzen da)',
    es: '✓ = asiste · vacío = no asiste (cuenta como falta en sesiones pasadas)',
  },
  // Issue #52, 2026-10-02: "en F7 y UKE Eskola, añade una mini pestañita desplegable que permita
  // seleccionar 'Todos asisten', 'No hay entrenamiento (festivo)' o 'Se suspende el entrenamiento'".
  // Mismas claves y mismo componente (`EstadoDiaMenu`) ya usado por F11 desde el issue #32/#45 —
  // movidas aquí (antes solo en `f11/i18n.ts`) para que ambos lados puedan compartirlo.
  estadoDiaTodos: { eu: 'Denak bertaratzen dira', es: 'Todos asisten' },
  estadoDiaFestivo: { eu: 'Entrenamendurik ez (Jaieguna)', es: 'No hay entrenamiento (Festivo)' },
  estadoDiaSuspendido: { eu: 'Entrenamendua bertan behera uzten da', es: 'Se suspende el entrenamiento' },
  nombre: { eu: 'Izena', es: 'Nombre' },
  anadir: { eu: '✔ Gehitu', es: '✔ Añadir' },
  cancelar: { eu: 'Utzi', es: 'Cancelar' },
  nota: { eu: '📝 Oharra', es: '📝 Nota' },
  eliminarNota: { eu: '🗑 Ezabatu', es: '🗑 Eliminar' },
  quitarDiaConfirm: { eu: 'Eguna kendu?', es: '¿Quitar este día?' },
  // Issue #65, 2026-10-09: "al hacer clic derecho sobre una sesión de un jugador... debe aparecer
  // una opción para eliminar esa sesión solo para ese jugador" — borra la marca y la nota de ESA
  // persona en ESA sesión (el resto de la plantilla y la sesión en sí no se tocan), y el % se
  // recalcula solo porque ya se calcula en vivo (no hace falta ningún paso extra). Reutilizado el
  // 2026-10-11 también para entrenadores (feedback del club: "ha pedido una opción para poder
  // eliminar un entrenamiento concreto" cuando un entrenador se incorpora a mitad de temporada y
  // las sesiones previas, sin marcar, le contaban como baja) — texto neutro ("esta persona") en vez
  // de "este jugador", válido para ambos casos.
  eliminarSesionJugador: {
    eu: '🗑️ Saioa ezabatu (pertsona honentzat)',
    es: '🗑️ Eliminar esta sesión (solo para esta persona)',
  },
  eliminarSesionJugadorConfirm: {
    eu: 'Pertsona honen saio hau ezabatu? Marka eta oharra galduko dira, eta ehunekoak automatikoki birkalkulatuko dira.',
    es: '¿Eliminar esta sesión para esta persona? Se pierde la marca y la nota, y los porcentajes se recalculan automáticamente.',
  },
  // Club por WhatsApp, 2026-10-13: motivo de la ausencia en Eskola/F7 (cuentan como falta en el %).
  faltaMotivo: { eu: 'Hutsegitea:', es: 'Falta:' },
  faltaEN: { eu: '🤒 Gaixorik', es: '🤒 Enfermo' },
  faltaLS: { eu: '🩹 Lesioa', es: '🩹 Lesión' },
  faltaJU: { eu: '📄 Justifikatua', es: '📄 Justificada' },
  faltaNJ: { eu: '❓ Arrazoirik gabe', es: '❓ Sin motivo' },
  eliminarJugadorConfirm: { eu: 'Jokalaria ezabatu?', es: '¿Eliminar jugador?' },
  fichaJugador: { eu: 'Jokalariaren fitxa', es: 'Ficha del jugador' },
  rolEntrenador: { eu: 'Rola', es: 'Rol' },
  totalPorc: { eu: 'Guztira %', es: 'Total %' },
  presencias: { eu: 'Presentziak', es: 'Presencias' },
  faltas: { eu: 'Faltak', es: 'Faltas' },
  sesiones: { eu: 'Saioak', es: 'Sesiones' },
  eliminarJugador: { eu: '🗑 Jokalaria ezabatu', es: '🗑 Eliminar jugador' },
  subirFoto: { eu: '📷 Argazkia igo', es: '📷 Subir foto' },
  cerrar: { eu: 'Itxi', es: 'Cerrar' },
  sinDatos: { eu: 'Ez dago daturik', es: 'Sin datos' },
  sinAcceso: { eu: 'Sarbiderik ez', es: 'Sin acceso' },
  sinAccesoAsistenciaMensaje: {
    eu: 'Ez duzu talde honen asistentziara sarbiderik.',
    es: 'No tienes acceso a la asistencia de este equipo.',
  },
  errorGenerico: { eu: 'Errore bat gertatu da', es: 'Ha ocurrido un error' },
  temporadaCerrada: {
    eu: 'Denboraldia itxita dago; datuak irakurtzeko soilik dira.',
    es: 'La temporada está cerrada; los datos son de solo lectura.',
  },
  // Feedback del club, 2026-10-05: "deberían verse todos igual que en f11... tanto eskola, como f7
  // y f11 deberían estar igual" — mismas claves que `f11/i18n.ts` (misma traducción literal), para
  // que Eskola/F7 adopten la misma estructura de tabla (numeración continua, Mensual/Anual,
  // secciones por grupo con total/media, tarjetas de resumen).
  porcMes: { eu: 'Hilabetekoa', es: 'Mensual' },
  porcAno: { eu: 'Urtekoa', es: 'Anual' },
  totalGeneral: { eu: 'GUZTIZKO GUZTIRA', es: 'TOTAL GENERAL' },
  media: { eu: 'Batez besteko', es: 'Media' },
  conFicha: { eu: 'Fitxadunak', es: 'Con Ficha' },
  sinFicha: { eu: 'Fitxarik gabekoak', es: 'Sin Ficha' },
  entrenadores: { eu: 'Entrenatzaileak', es: 'Entrenadores' },
  totalTemporada: { eu: 'Denboraldiko guztira', es: 'Total temp.' },
  asistencias: { eu: 'Asistentziak', es: 'Asistencias' },
  mediaGeneral: { eu: 'Batez bestekoa (%)', es: 'Media general %' },
  mediaFicha: { eu: 'Fitxa batez bestekoa (%)', es: 'Media ficha %' },
  editarDias: { eu: 'Editatu', es: 'Editar' },
  guardarDias: { eu: 'Gorde', es: 'Guardar' },
} as const

export type DictKey = keyof typeof DICT


export function t(key: DictKey, lang: Lang): string {
  return DICT[key][lang]
}

const MESES: Record<string, { eu: string; es: string }> = {
  '01': { eu: 'Urtarrila', es: 'Enero' },
  '02': { eu: 'Otsaila', es: 'Febrero' },
  '03': { eu: 'Martxoa', es: 'Marzo' },
  '04': { eu: 'Apirila', es: 'Abril' },
  '05': { eu: 'Maiatza', es: 'Mayo' },
  '06': { eu: 'Ekaina', es: 'Junio' },
  '07': { eu: 'Uztaila', es: 'Julio' },
  '08': { eu: 'Abuztua', es: 'Agosto' },
  '09': { eu: 'Iraila', es: 'Septiembre' },
  '10': { eu: 'Urria', es: 'Octubre' },
  '11': { eu: 'Azaroa', es: 'Noviembre' },
  '12': { eu: 'Abendua', es: 'Diciembre' },
}

export function mesLabel(mes: string, lang: Lang): string {
  const [, mm] = mes.split('-')
  return MESES[mm]?.[lang] ?? mes
}

const DIAS_SEMANA: Record<number, { eu: string; es: string }> = {
  1: { eu: 'Al', es: 'Lu' },
  2: { eu: 'Ar', es: 'Ma' },
  3: { eu: 'Az', es: 'Mi' },
  4: { eu: 'Og', es: 'Ju' },
  5: { eu: 'Or', es: 'Vi' },
  6: { eu: 'Lr', es: 'Sá' },
  7: { eu: 'Ig', es: 'Do' },
}

export function diaSemanaLabel(fechaISO: string, lang: Lang): string {
  const date = new Date(`${fechaISO}T00:00:00Z`)
  const dow = date.getUTCDay() === 0 ? 7 : date.getUTCDay()
  return DIAS_SEMANA[dow]?.[lang] ?? ''
}
